import React, { useState, useEffect } from "react";
import API from "../../../Utils/api";

// Skeleton Card
const CategorySkeleton = () => (
  <div className="flex flex-col items-center border rounded-sm overflow-hidden animate-pulse">
    <div className="w-full h-48 bg-gray-200" />
    <div className="h-4 bg-gray-200 rounded w-3/4 my-5" />
  </div>
);

const Category = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchCategories = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await API.get("/category/all");
      setCategories(res.data.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setError("Failed to load categories. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="w-full px-4 sm:px-6 md:px-10 py-4 flex flex-col items-center bg-yellow-50/30">
      <h3 className="text-2xl md:text-4xl font-serif  text-[#000000] mt-5">
        Explore By Category
      </h3>

      {/* Error State */}
      {error && !loading && (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <span className="text-5xl mb-4">😕</span>
          <p className="text-gray-600 font-medium text-lg">{error}</p>
          <button
            onClick={fetchCategories}
            className="mt-4 px-6 py-2 bg-[#3A7138] text-white rounded-lg text-sm hover:bg-[#92AD36] transition"
          >
            Try Again
          </button>
        </div>
      )}

      {/* Empty State */}
      {!loading && !error && categories.length === 0 && (
        <div className="flex flex-col items-center justify-center py-16 text-center">
          <span className="text-5xl mb-4">📂</span>
          <p className="text-gray-600 font-medium text-lg">
            No categories available
          </p>
          <p className="text-gray-400 text-sm mt-1">
            Check back soon for updates
          </p>
        </div>
      )}

      {/* Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mt-10 w-full">
        {loading
          ? Array.from({ length: 5 }).map((_, i) => (
              <CategorySkeleton key={i} />
            ))
          : categories.map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center gap-5 border hover:border-[#92AD36] rounded-xl mb-5 transition hover:scale-105 duration-300 hover:shadow-xl hover:backdrop-blur-sm overflow-hidden"
              >
                <img
                  src={item.image}
                  alt={item.category}
                  className="w-full h-48 object-cover"
                />
                <span className="text-center text-base leading-relaxed tracking-wider line-clamp-1 mb-5 px-2">
                  {item.category}
                </span>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Category;
